import { createFileRoute } from '@tanstack/react-router';

import { GradeConfigTemplate, useGradeConfigData } from '@/features/grade-attendance-config';

export const Route = createFileRoute('/_authenticated/exam/grade-config/' as never)({
  component: GradeConfigPage,
});

/**
 * Página de Configuração de Nota e Frequência — wireia a fronteira de dados
 * (`useGradeConfigData`) ao template da feature. O empty state (nenhuma turma) e os estados
 * de carregamento/erro da turma selecionada são resolvidos dentro do template.
 */
export function GradeConfigPage() {
  const { isLoading, isError, refetch } = useGradeConfigData();

  return <GradeConfigTemplate isLoading={isLoading} isError={isError} onRetry={() => refetch()} />;
}
